import React from 'react';

const useEscapedHandler = (handler, callback) => {
    React.useEffect(() => {
        const escFunction = handler(() => callback());
        document.addEventListener('keydown', escFunction, false);
        return () => {
            document.removeEventListener('keydown', escFunction, false);
        };
    }, [handler, callback]);
};

export default useEscapedHandler;
